export enum UserStatusEnum {
  STANDARD = 'STANDARD',
  FIRST_TIME = 'FIRST_TIME',
  PASSWORD_RESET = 'PASSWORD_RESET',
  BANNED = 'BANNED',
  DEACTIVATED = 'DEACTIVATED',
  DELETED = 'DELETED',
  GUEST = 'GUEST',
}
